var exports = {
  "kL": "CollapsedCategoryVoiceParticipants.module__container___ajJsOT",
  "Kk": "CollapsedCategoryVoiceParticipants.module__icon___ajJsOT",
  "nU": "CollapsedCategoryVoiceParticipants.module__channelContainer___ajJsOT",
};

module.exports = exports;
